


import Admin, { hasRole, Role } from '@/models/Admin'
import Transaction from '@/models/Transaction'

export default class TransactionPolicy {
    viewAny(_admin: Admin): boolean {
        return true
    }

    view(admin: Admin, transaction: Transaction) {
        return hasRole(admin, [Role.SUPER_ADMIN,Role.COUNTRY_MANAGER,Role.STATION_MANAGER, Role.STATION_OFFICER])
    }

    create(admin: Admin) {
        return hasRole(admin, [Role.SUPER_ADMIN,Role.COUNTRY_MANAGER,Role.STATION_MANAGER,Role.STATION_OFFICER])
    }

    update(admin: Admin, transaction: Transaction) {
        return hasRole(admin, [Role.SUPER_ADMIN])
    }

    restore(admin: Admin, transaction: Transaction) {
        return hasRole(admin, [Role.SUPER_ADMIN])
    }

    delete(admin: Admin, transaction: Transaction) {
        return hasRole(admin, [Role.SUPER_ADMIN])
    }

    forceDelete(_admin: Admin, _transaction: Transaction) {
        return false
    }
}
